import { RecourseForwardProps } from '@/src/app/basvuru/[page]/yonlendirme/client.page';
import { RecourseInfo } from '../recourse-info/recourse-info';

export const RecourseRedirectContainer = ({
  params,
  searchParams,
  referrerUrl,
}: RecourseForwardProps & { referrerUrl?: string }) => {
  return (
    <div className="flex w-full flex-col md:bg-gray-100">
      <RecourseInfo referrerUrl={referrerUrl} params={params} searchParams={searchParams} />
    </div>
  );
};
